import React from "react";

export function CopyIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="copy">
        <g id="vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.08183 7.49828C5.08183 6.16359 6.16381 5.08161 7.49849 5.08161H15.8367C17.1714 5.08161 18.2534 6.16359 18.2534 7.49828V15.8365C18.2534 17.1712 17.1714 18.2531 15.8367 18.2531H7.49849C6.1638 18.2531 5.08183 17.1712 5.08183 15.8365V7.49828ZM7.49849 6.58161C6.99223 6.58161 6.58183 6.99202 6.58183 7.49828V15.8365C6.58183 16.3427 6.99223 16.7531 7.49849 16.7531H15.8367C16.3429 16.7531 16.7534 16.3427 16.7534 15.8365V7.49828C16.7534 6.99202 16.3429 6.58161 15.8367 6.58161H7.49849Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.16419 3.24707C3.65754 3.24707 3.24683 3.65779 3.24683 4.16443V12.5012C3.24683 13.0079 3.65754 13.4186 4.16419 13.4186H5.83155C6.24576 13.4186 6.58155 13.7544 6.58155 14.1686C6.58155 14.5828 6.24576 14.9186 5.83155 14.9186H4.16419C2.82912 14.9186 1.74683 13.8363 1.74683 12.5012V4.16443C1.74683 2.82936 2.82912 1.74707 4.16419 1.74707H12.501C13.8361 1.74707 14.9184 2.82936 14.9184 4.16443V5.83179C14.9184 6.24601 14.5826 6.58179 14.1684 6.58179C13.7541 6.58179 13.4184 6.24601 13.4184 5.83179V4.16443C13.4184 3.65779 13.0076 3.24707 12.501 3.24707H4.16419Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
